import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';

export function getClassroomToDisplay(
  classroomIds: string[],
  allClassrooms: Classroom[],
  classroomsOrg: ClassroomsOrg,
): Classroom[] {
  // On peut tomber dans le cas où un evènement était affecté à plusieurs classrooms
  // et l'utilisateur change les jours travaillés...
  // donc la séance a toujours ses x classrooms, d'où le <= et pas le ===
  const sameNumberOfClassrooms = allClassrooms.length <= classroomIds.length;
  const matchingClassrooms = allClassrooms.filter(c =>
    classroomIds.includes(c.id),
  );
  if (
    classroomsOrg === 'split' ||
    sameNumberOfClassrooms ||
    matchingClassrooms.length === 0
  ) {
    return [];
  }

  return matchingClassrooms;
}
